import { useMsal } from '@azure/msal-react';
import Loading from '@src/main/ui/components/layout/common/Loading/Loading';
import { type FC } from 'react';

const Login: FC = () => {
  const { instance } = useMsal();
  instance.loginRedirect();

  return <Loading />;
};

export default Login;
